module.exports = __webpack_public_path__ + "img/second-day-7.512c3f19.png";